export default __webpack_public_path__ + "static/media/icon-menu.7f045ef9.svg";